export const DESCRIPTION_PADDINGS = {
  SIZE_10: '--description-paddings-size-10',
  SIZE_20: '--description-paddings-size-20',
  SIZE_30: '--description-paddings-size-30',
  SIZE_40: '--description-paddings-size-40',
} as const
export type DESCRIPTION_PADDINGS =
  (typeof DESCRIPTION_PADDINGS)[keyof typeof DESCRIPTION_PADDINGS]
